<template>
  <div class="main">
    <!-- <img class="login-bg" src="/login_bg.png" /> -->
    <van-form @submit="login">
      <div class="form">
        <div class="input-title">账号：</div>
        <div class="input">
          <van-field v-model="username" name="username" type="username"
            :rules="[{ required: true, message: '请填写账号' }]" />
        </div>
        <div class="input-title">密码：</div>
        <div class="input">
          <van-field v-model="password" name="password" :type="passwordType"
            :rules="[{ required: true, message: '请填写密码' }]">
            <template slot="right-icon">
              <span class="solts" @click="switchPasswordType">
                <van-icon name="eye" v-if="passwordType === 'password'" />
                <van-icon name="closed-eye" v-else />
              </span>
            </template>
          </van-field>
        </div>
        <van-checkbox checked-color="#32B8C7" icon-size="20px" v-model="rememberPassword">
          <div style="color: #93a2ad; font-size: 18px">记住密码</div>
        </van-checkbox>
        <van-button class="btn" native-type="submit">登录</van-button>
      </div>
    </van-form>
    <el-dialog title="请选择岗位" :visible="showPostDialog" width="95%" @close="showPostDialog = false">
      <div class="tree">
        <el-tree ref="tree" v-loading="switchLoading" :data="filteredTree" :props="props" node-key="key"
          :expand-on-click-node="false" default-expand-all check-on-click-node check-strictly show-checkbox
          @check-change="handleCheckChange">
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button style="width: 100%" type="primary" round :loading="switchLoading" @click="switchLogin">确
          定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import Wartermark from '@/utils/wartermark'
import sensors from 'sa-sdk-javascript'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getAction, postAction } from '@/api/manage'
export default {
  data() {
    return {
      username: '',
      password: '',
      passwordType: 'password',
      rememberPassword: false,
      switchLoading: false, // 切换岗位按钮是否禁用
      showPostDialog: false, // 是否显示岗位选择弹窗
      postData: [], // 岗位数据
      chooseIdList: [], // 用户的岗位ID列表
      checkedKeys: [], // 选中的岗位key
      selectedPostNode: null, // 选中的岗位节点
      props: {
        label: 'title',
        children: 'children',
      },
    }
  },
  computed: {
    // 将数字数组转为Set提升查询效率
    idFilterSet() {
      return new Set(this.chooseIdList)
    },

    // 过滤后的树数据
    filteredTree() {
      return this.deepFilter(this.postData)
    },
  },
  created() {
    if (Vue.ls.get('rememberPassword')) {
      this.getRememberPassword()
    }
  },
  methods: {
    // 是否显示密码
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    },
    // 获取记住密码
    getRememberPassword() {
      this.username = Vue.ls.get('username')
      this.password = Vue.ls.get('password')
      this.rememberPassword = Vue.ls.get('rememberPassword')
    },
    // 登录权限控制
    getPermission() {
      getAction('/sys/permission/getUserPermissionByTokenMobile').then(res => {
        console.log('登录权限控制------', res)
        if (res.result.isMobileAccessPermissions) {
          const authData = res.result.auth
          sessionStorage.setItem('LOGIN_USER_BUTTON_AUTH', JSON.stringify(authData))
          this.$toast.success('登陆成功')
          this.$router.push('/dataBoard')
        } else {
          this.$toast('本应用仅适用于销售团队，销售团队中新入职员工请联系助理')
        }
      })
    },
    // 判断当前登录的账户是否是助理
    getIsRegionalAssistant() {
      getAction('/sys/permission/getIsRegionalAssistant').then(res => {
        if (res.result.isRegionalAssistant) {
          Vue.ls.set('isRegionalAssistant', res.result.isRegionalAssistant)
          // 获取助理对应的岗位列表
          this.getPerationalPost()
        } else {
          this.getPermission()
          Vue.ls.set('isRegionalAssistant', res.result.isRegionalAssistant)
        }
      })
    },
    // 获取助理对应的岗位列表
    getPerationalPost() {
      getAction('/sys/sysassistantpost/getPerationalPost').then(res => {
        getAction('/sys/sysassistantpost/getChoosePost').then(r => {
          if (res.success) {
            this.postData = res.result // 岗位数据
            this.chooseIdList = r.result
            Vue.ls.set('postData', this.filteredTree)
            this.showPostDialog = true // 显示岗位选择弹窗
          }
        })
      })
    },
    deepFilter(nodes) {
      return nodes
        .map(node => {
          const newNode = { ...node } // 创建副本避免污染原始数据

          // 递归处理子节点
          if (newNode.children) {
            newNode.children = this.deepFilter(newNode.children)
          }

          // 判断保留条件：
          // 1. 当前节点在选中ID列表中
          // 2. 或处理后子节点非空
          const isMatched = this.idFilterSet.has(newNode.key)
          const hasValidChildren = newNode.children?.length > 0
          if (isMatched) {
            newNode.disabled = false // 强制启用可见节点
          } else if (hasValidChildren) {
            // 路径节点保持原有状态
            newNode.disabled = newNode.disabled ?? true
          }
          return isMatched || hasValidChildren ? newNode : null
        })
        .filter(node => node !== null)
    },
    // 选择岗位
    handleCheckChange(data, checked) {
      if (checked) {
        this.$refs.tree.setCheckedKeys([data.key]) // 强制单选逻辑
        this.selectedPostNode = data
      } else if (this.selectedPostNode && this.selectedPostNode.key === data.key) {
        this.selectedPostNode = null
      }
      this.checkedKeys = this.$refs.tree.getCheckedKeys()
    },
    // 确定切换岗位
    switchLogin() {
      this.switchLoading = true // 切换岗位按钮禁用
      if (this.checkedKeys.length === 0 || !this.selectedPostNode) {
        this.$toast('请选择岗位')
        this.switchLoading = false // 切换岗位按钮解禁
        return
      }
      const params = {
        switchTerritoryId: this.selectedPostNode.key,
        switchUserWorkNo: this.selectedPostNode.workNo,
        switchYm: this.selectedPostNode.ym,
        jurisdictionType: this.selectedPostNode.jurisdictionType,
      }
      postAction('/sys/switchLogin', params).then(res => {
        if (res.success) {
          if (res.result && res.result.token) {
            Vue.ls.set(ACCESS_TOKEN, res.result.token)
          }
          Vue.ls.set('postKey', this.checkedKeys) // 储存选择的岗位key
          Vue.ls.set('username', this.username) // 储存用户信息
          Vue.ls.set('password', this.password) // 储存用户信息
          this.switchLoading = false // 切换岗位按钮解禁
          this.showPostDialog = false // 显示岗位选择弹窗
          this.getPermission()
        }
      })
    },
    login(values) {
      postAction('/sys/login', values).then(res => {
        if (res.code == 200) {
          if (this.rememberPassword) {
            Vue.ls.set('username', this.username)
            Vue.ls.set('password', this.password)
          } else {
            Vue.ls.remove('username')
            Vue.ls.remove('password')
          }
          Vue.ls.set('rememberPassword', this.rememberPassword)
          Vue.ls.set(ACCESS_TOKEN, res.result.token)
          Vue.ls.remove('postKey')
          Vue.ls.remove('currentPositionLabel')
          // Vue.ls.set('territoryType', res.result.territoryType)
          sensors.init({
            server_url:
              process.env.VUE_APP_SENSORS_API_BASE_URL + `/sys/sensors/report?token=${res.result.token}&type=mobile`,
            is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
            use_client_time: true,
            send_type: 'beacon',
            heatmap: {
              //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
              clickmap: 'default',
              //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
              scroll_notice_map: 'not_collect',
            },
          })

          sensors.quick('autoTrack') //用于采集 $pageview 事件。
          Vue.prototype.$sensors = sensors

          // 登录权限控制
          this.getIsRegionalAssistant()
          // this.getPermission()
          // this.getInfo()
          // this.$toast.success('登陆成功')
          // this.$router.push('/dataBoard')
        } else {
          this.$toast(res.message)
        }
      })
    },
    getInfo() {
      getAction('/sys/order/my/information').then(res => {
        console.log('我的信息--------', res)
        if (res.success) {
          Vue.ls.set('ntid', res.result.ntid)
          Wartermark.set(Vue.ls.get('ntid'))
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/ .is-disabled {
  display: none;
}

.main {
  height: 100vh;
  background-color: #fff;
}

.tree {
  height: 300px;
  overflow: auto;
}

::-webkit-scrollbar {
  display: none;
}

.login-bg {
  width: 100%;
}

.form {
  padding: 0 24px;
  margin-top: 10px;

  .input-title {
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    margin-top: 15px;
  }

  .input {
    margin: 9px 0;
    display: flex;
    align-items: center;
    border: 1px solid #32b8c7;
    border-radius: 6px;

    /deep/ .van-field {
      background-color: transparent;

      &::after {
        border: none;
      }

      &__control {
        font-size: 18px;
      }
    }

    >span {
      flex-shrink: 0;
      font-weight: 600;
      margin-right: 16px;
    }
  }

  .btn {
    z-index: 999;
    width: 100%;
    height: 42px;
    background: #32b8c7;
    border-radius: 10px;
    margin-top: 30px;
    color: #fff;
    font-weight: 500;
    border: none;
  }
}
</style>
